/**
 * VideoSyncPanelWrapper Component
 * Wrapper for Video Sync panel
 */

import React from 'react';
import { VideoSyncPanel } from '../video';

export const VideoSyncPanelWrapper = ({
  isOpen,
  onClose,
  projectId,
  currentTime,
  isPlaying,
  onTimeUpdate,
  onPlayStateChange,
  bpm,
}) => {
  return (
    <VideoSyncPanel
      isOpen={isOpen}
      onClose={onClose}
      projectId={projectId}
      currentTime={currentTime}
      isPlaying={isPlaying}
      onTimeUpdate={onTimeUpdate}
      onPlayStateChange={onPlayStateChange}
      bpm={bpm}
    />
  );
};

export default VideoSyncPanelWrapper;
